import styled from '@emotion/styled';
import { node, number, oneOfType, string } from 'prop-types';
import Box from './Box';

const OuterCluster = styled(Box)(
  ({
    theme,
    gap = 'm',
    vGap = gap,
    hGap,
    innerFlex,
    maxWidth = '37.5rem',
    removeEmpty,
  }) => ({
    maxWidth,
    '> *': {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      margin: `${(theme.space?.[vGap] / 2) * -1}px ${
        (theme.space?.[hGap] / 2) * -1
      }px`,
    },

    '> * > *': {
      margin: `${theme.space?.[vGap] / 2}px ${theme.space?.[hGap] / 2}px`,
      flex: innerFlex === 1 ? '1 0 0px' : innerFlex,
      '&:empty': { display: removeEmpty ? 'none' : null}
    },
  })
);

const Cluster = ({ children, flex, ...props }) => (
  <OuterCluster innerFlex={flex} {...props}>
    <div>{children}</div>
  </OuterCluster>
);

Cluster.defaultProps = {
  hGap: 'l',
};

Cluster.propTypes = {
  space: string,
  hGap: string,
  children: node.isRequired,
  flex: oneOfType([string, number]),
};

export default Cluster;
